"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const index_vue_1 = __importDefault(require("./comment/index.vue"));
const index_vue_2 = __importDefault(require("./commend/index.vue"));
const index_vue_3 = __importDefault(require("./config/index.vue"));
const HeaderTop_vue_1 = __importDefault(require("@/components/HeaderTop/HeaderTop.vue"));
const productDetail_1 = require("@/api/productDetail");
const goodDetail_1 = require("@/api/goodDetail");
const store_1 = require("@/store");
const cop_1 = __importDefault(require("@/components/packageSet/cop"));
const Lop_1 = __importDefault(require("@/components/packageSet/Lop"));
const wheel_1 = __importDefault(require("@/components/packageSet/wheel"));
const guide_1 = __importDefault(require("@/components/packageSet/guide"));
let GoodDetail = class GoodDetail extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        this.colors = ['#99A9BF', '#F7BA2A', '#FF9900'];
        this.currentGoodsId = null;
        this.commendList = [];
        this.visible = false;
        this.picList = [];
        this.shuxingPrice = 0;
        this.guigePrice = 0;
        this.calculationPrice = 0;
        this.chinGuigeName = '';
        this.chinShuxingName = '';
        this.wheelId = '';
        this.goodsDetail = {};
        this.lopList = {};
        this.copList = {};
        this.wopList = {};
        this.gopList = {};
        this.fopList = {};
        this.showLop = false;
        this.showCop = false;
        this.showGuide = false;
        this.copType = '';
        this.showWeel = false;
        this.showlift = false;
        this.propertys = [];
        this.child = [];
        this.form = {
            orderNum: 1,
            guige: '',
            shuxing: '',
            wareHouseId: ''
        };
        this.childId = '';
        this.wareHouseList = [];
        // @Watch('$route') routeChange () {
        //   this.getDetail({ id: this.currentGoodsId,loginToken: this.userInfo.loginToken })
        // }
    }
    // onLoad (e: any) {
    //   const el = e.path[0]
    //   ImageScale(el, 490, 490)
    // }
    updataCop(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.purchasePrice) {
                this.goodsDetail.actualPrice = item.purchasePrice;
                this.calculationPrice = item.purchasePrice;
            }
            this.goodsDetail.suitConfig = this.tocn(JSON.stringify(item));
            if (this.showLop) {
                let logo = '';
                let duse = '';
                // 蓝光 24v 带盲文 SN-PB12 (pcs: 2)111|-|SFTC-HCB-D5 SN-HCB-D5有LOGO 镀色  1
                //console.log(item, 'items')
                if (item.haveLogo != '' && item.haveColor == '') {
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    // this.goodsDetail.purchasePrice = pp + 20
                }
                if (item.haveLogo != '' && item.haveColor != '') {
                    duse = '镀色';
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    // this.goodsDetail.purchasePrice = pp + 30
                }
                if (item.haveColor != '' && item.haveLogo == '') {
                    duse = '镀色';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    // this.goodsDetail.purchasePrice = pp + 10
                }
                // let salesPriceCk = (Number(this.goodsDetail.purchasePrice) / Number(this.rateR) / parseFloat(1 + Number(this.goodsDetail.rebate) / 100)) * (1 + (Number(this.goodsDetail.profitRateD) + Number(this.goodsDetail.profitRateG)) / 200)
                // console.log(item.lopButtonDesc04,"item.lopButtonDesc04")
                this.goodsDetail.chnitemproperty = item.lopDes + ' ' + item.lopButtonDesc01 + ' ' + item.lopButtonDesc02 + ' ' + item.lopButtonDesc03 + ' ' + item.lopButtonDesc04 + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ')' + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + logo + ' ' + duse + ' ' + item.haveColor01;
                this.goodsDetail.itemproperty = item.lop + ' ' + this.pingyin(item.lopButtonDesc01) + ' ' + item.lopButtonDesc02 + ' ' + this.pingyin(item.lopButtonDesc03) + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ')' + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + this.pingyin(logo) + ' ' + this.pingyin(duse) + ' ' + item.haveColor01;
            }
            if (this.showCop) {
                let logo = '';
                let duse = '';
                if (item.haveLogo != '' && item.haveColor == '') {
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    // this.goodsDetail.purchasePrice = pp + 20
                }
                if (item.haveLogo != '' && item.haveColor != '') {
                    duse = '镀色';
                    logo = '有LOGO';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    // this.goodsDetail.purchasePrice = pp + 70
                }
                if (item.haveColor != '' && item.haveLogo == '') {
                    duse = '镀色';
                    // let pp = await this.getpurchasePrice(this.goodsDetail.itemNo)
                    // this.goodsDetail.purchasePrice = pp + 50
                }
                // let salesPriceCk = (Number(this.goodsDetail.purchasePrice) / Number(this.rateR) / parseFloat(1 + Number(this.goodsDetail.rebate) / 100)) * (1 + (Number(this.goodsDetail.profitRateD) + Number(this.goodsDetail.profitRateG)) / 200)
                let car = '';
                if (item.ccb) {
                    if (item.ccb.includes("&&")) {
                        car = ('电梯轿厢控制板:' + item.ccb.split('&&')[0].split('||')[0] + ';' + '电梯指令板:' + item.ccb.split('&&')[1].split('||')[0]);
                    }
                    else {
                        car = ('操纵箱指令板:' + item.ccb.split('||')[0]);
                    }
                }
                car = car + ';' + item.ccbDesc;
                let encar = '';
                if (item.ccb) {
                    if (item.ccb.includes("&&")) {
                        encar = ('Car Control Board:' + item.ccb.split('&&')[0].split('||')[0] + ';' + 'Car Call Board:' + item.ccb.split('&&')[1].split('||')[0]);
                    }
                    else {
                        encar = ('Command Board:' + item.ccb.split('||')[0]);
                    }
                }
                this.goodsDetail.chnitemproperty = 'floor:' + item.floor + ' ' + item.lopButtonDesc01 + ' ' + item.lopButtonDesc02 + ' ' + item.lopButtonDesc03 + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ') ' + item.floorContent + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + car + ' ' + logo + ' ' + duse + ' ' + item.haveColor01;
                this.goodsDetail.itemproperty = 'floor:' + item.floor + ' ' + this.pingyin(item.lopButtonDesc01) + ' ' + item.lopButtonDesc02 + ' ' + this.pingyin(item.lopButtonDesc03) + ' ' + item.button.split('||')[0] + '(pcs:' + item.buttonNums + ') ' + item.floorContent + ' ' + item.lopDisplayDesc + '|-|' + item.display.split('||')[0] + ' ' + encar + ' ' + this.pingyin(logo) + ' ' + this.pingyin(duse) + ' ' + item.haveColor01;
            }
            if (this.showGuide) {
                //   78*60*16.4mm  pcs : 2; Fish Plate-TK5AD  pcs : 3; T-Clips-TK5AD  pcs : 4; M10*30  pcs : 5;   pcs : 2; Fish Plate-TK5AD  pcs : 8; T-Clips-TK5AD  pcs : 4; M10*30  pcs : 5;
                this.goodsDetail.chnitemproperty = item.guideRail.split('||')[0] + ' ' + 'pcs:' + item.guideRailNums + ' ' + item.fishPlate.split('||')[0] + ' ' + 'pcs:' + ' ' + item.fishPlateNums + ' ' + item.tClips.split('||')[0] + ' ' + 'pcs:' + ' ' + item.tClipsNums + ' ' + ' ' + item.bolts.split('||')[0] + ' ' + 'pcs:' + ' ' + item.boltsNums;
                this.goodsDetail.itemproperty = item.guideRail.split('||')[0] + ' ' + 'pcs:' + item.guideRailNums + ' ' + item.fishPlate.split('||')[0] + 'pcs:' + ' ' + item.fishPlateNums + ' ' + item.tClips.split('||')[0] + ' ' + 'pcs:' + ' ' + item.tClipsNums + ' ' + item.bolts.split('||')[0] + 'pcs:' + ' ' + item.boltsNums;
            }
            if (this.showWeel) {
                //   console.log(item,'888')
                this.goodsDetail.chnitemproperty = item.wheel.split('||')[0] + ' ' + ':' + item.bearing.split('||')[0] + ' ' + item.sl.split('||')[0] + ' ' + item.check24 + ' ';
                const eng = (item.wheel.split('||')[0] + ' ' + ':' + item.bearing.split('||')[0] + ' ' + item.sl.split('||')[0] + ' ' + item.check24 + ' ');
                this.goodsDetail.itemproperty = eng.replace('国产', 'HRB').replace('人本', 'C&U');
            }
            this.close();
        });
    }
    close() {
        this.showCop = false;
        this.showLop = false;
        this.showWeel = false;
        this.showGuide = false;
        this.showlift = false;
    }
    pingyin(val) {
        let ss = '';
        if (val == '蓝光') {
            ss = 'blue';
        }
        if (val == '红光') {
            ss = 'red';
        }
        if (val == '绿光') {
            ss = 'green';
        }
        if (val == '橙光') {
            ss = 'orange';
        }
        if (val == '白光') {
            ss = 'white';
        }
        if (val == '有LOGO') {
            ss = 'With LOGO';
        }
        if (val == '镀色') {
            ss = 'With Color';
        }
        if (val == '带盲文') {
            ss = 'with_Braille';
        }
        if (val == '不带盲文') {
            ss = 'without_Braill';
        }
        if (val == '电梯轿厢控制板') {
            ss = 'Car Control Board';
        }
        if (val == '电梯指令板') {
            ss = 'Car Call Board';
        }
        return ss;
    }
    tocn(val) {
        const v = val;
        return v.replace('blue', '蓝光')
            .replace('red', '红光')
            .replace('green', '绿光')
            .replace('orange', '橙光')
            .replace('white', '白光')
            .replace('+$5', '+20RMB')
            .replace('+$10(One+$0.5)', '+50RMB(单个按钮+3RMB)')
            .replace('have braille', '带盲文')
            .replace('no braille', '不带盲文')
            .replace('Yes', '是')
            .replace('No', '否');
    }
    toen(val) {
        const v = val;
        return v.replace('蓝光', 'blue')
            .replace('红光', 'red')
            .replace('绿光', 'green')
            .replace('橙光', 'orange')
            .replace('白光', 'white')
            .replace('+20RMB', '+$5')
            .replace('+50RMB(单个按钮+3RMB)', '+$10(One+$0.5)')
            .replace('带盲文', 'have braille')
            .replace('不带盲文', 'no braille')
            .replace('是', 'Yes')
            .replace('否', 'No');
    }
    config() {
        const item = this.goodsDetail;
        this.visible = true;
        this.lopList = {};
        this.copList = {};
        this.wopList = {};
        this.gopList = {};
        this.fopList = {};
        if (item.itemsCategory == '08 LOP') {
            this.showLop = true; //LOP参数显示
            this.copType = item.model;
            if (item.suitConfig) {
                this.copList = JSON.parse(this.toen(item.suitConfig));
            }
        }
        else if (item.itemsCategory == '07 COP') {
            this.showCop = true;
            this.copType = item.model;
            if (item.suitConfig) {
                this.copList = JSON.parse(this.toen(item.suitConfig));
            }
        }
        else if (item.chnitemName == '导轨') {
            this.showGuide = true;
            this.copType = item.model;
            if (item.suitConfig) {
                this.copList = JSON.parse(this.toen(item.suitConfig));
            }
            // this.showgoods02 = true //导轨参数显示
        }
        else if (item.itemsCategory == '01 导向轮 Diverting Pulleys') {
            this.showWeel = true;
            this.copType = item.model;
            this.wheelId = item.itemNo;
            if (item.suitConfig) {
                this.copList = JSON.parse(this.toen(item.suitConfig));
            }
            // this.showgoods08 = true //导向轮
        }
        else if (item.chnitemName == '轿厢') {
            this.showlift = true;
            this.copType = item.model;
            if (item.suitConfig) {
                this.copList = JSON.parse(this.toen(item.suitConfig));
            }
        }
    }
    // 动态商品单价
    getcalculationPrice() {
        // console.log(this.form.shuxing,"123")
        // console.log(this.form.guige,"123")
        if (this.form.shuxing && this.form.guige) {
            this.calculationPrice = this.shuxingPrice * 1 + this.guigePrice * 1;
        }
        else if (this.form.guige && !this.form.shuxing) {
            this.calculationPrice = this.guigePrice * 1;
        }
        else if (this.form.shuxing && !this.form.guige) {
            this.calculationPrice = this.goodsDetail.actualPrice * 1 + this.shuxingPrice * 1;
        }
        else {
            this.calculationPrice = this.goodsDetail.actualPrice;
        }
    }
    // 属性价格
    changeProperty(item) {
        this.shuxingPrice = item.price;
        this.chinShuxingName = item.cname;
        this.getcalculationPrice();
    }
    // 规格价格
    changeGuige(item, id) {
        if (id) {
            console.log(id);
            this.childId = item.id;
        }
        this.guigePrice = item.actualPrice;
        this.chinGuigeName = item.specification;
        // if(index||index===0){
        //   setTimeout(()=>{
        //     window.location.hash = "#"+'crumb-wrap'
        //   },500)
        // }
        this.getcalculationPrice();
    }
    getDetail(params) {
        productDetail_1.productDetail(params).then(res => {
            // 左下角推荐产品
            this.commendList = res.commendList;
            // 产品图片
            this.picList = res.picList;
            this.goodsDetail = res.detail;
            this.child = res.child;
            let obj = {};
            if (res.child && res.child.length > 0) {
                obj = res.child[0];
                console.log(obj);
                this.changeGuige(obj, obj.id);
            }
            else {
                obj = res.detail;
                this.changeGuige(obj);
            }
            this.form.guige = obj.engspecification;
            // 属性
            this.propertys = res.propertys;
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.tkd.keywords);
            document.querySelector('meta[name="description"]').setAttribute('content', res.tkd.description);
            document.title = res.tkd.title;
            if (this.propertys && this.propertys.length > 0) {
                this.propertys.forEach(item => {
                    if (item.itemproperty) {
                        let itemproperty = JSON.parse(item.itemproperty);
                        if (itemproperty && itemproperty.length > 0) {
                            this.changeProperty(itemproperty[0]);
                            this.form.shuxing = itemproperty[0].ename;
                        }
                    }
                });
            }
            this.getcalculationPrice();
        });
    }
    // getWareHouse(){
    //   getWareHouseList({id:this.currentGoodsId}).then((res: any)=>{
    //     console.log(res)
    //     this.wareHouseList=res
    //   })
    // }
    mounted() {
        this.currentGoodsId = this.$route.params.id;
        this.getDetail({ content: this.currentGoodsId, loginToken: this.userInfo.loginToken });
        //this.getWareHouse()
    }
    // 加购
    addCar(goods) {
        return __awaiter(this, void 0, void 0, function* () {
            // 是否登陆
            if (!this.userInfo) {
                this.$notify.error(this.$t('请先登录'));
                return;
            }
            // 没选规格
            if (!this.form.guige) {
                this.$notify.error(this.$t('请选择规格'));
                return;
            }
            // 没选属性
            if (this.propertys.length && !this.form.shuxing) {
                this.$notify.error(this.$t('请选择商品属性'));
                return;
            }
            let itemproperty = this.goodsDetail.itemproperty ? this.goodsDetail.itemproperty : (this.form.shuxing && this.form.guige ? this.form.shuxing + ',' + this.form.guige : this.form.shuxing + this.form.guige);
            let chnitemproperty = this.goodsDetail.chnitemproperty ? this.goodsDetail.chnitemproperty : (this.chinShuxingName + this.form.shuxing ? ',' : '' + this.chinGuigeName);
            const req = {
                childId: this.childId,
                customer: this.userInfo.name || '',
                customerId: this.userInfo.id || '',
                itemId: this.goodsDetail.id,
                itemproperty: itemproperty,
                // itemproperty: this.form.shuxing + this.form.shuxing ? ',' : '' + this.form.guige,
                chnitemproperty: chnitemproperty,
                loginToken: this.userInfo.loginToken,
                orderNum: this.form.orderNum,
                // wareHouseId:this.form.wareHouseId.split("+")[0],
                // wareHouseName:this.form.wareHouseId.split("+")[1],
                remark: '',
                salesAmount: this.calculationPrice * this.form.orderNum,
                salesPrice: this.calculationPrice,
                suitConfig: this.goodsDetail.suitConfig // 套装配置
            };
            if (req.suitConfig == null && this.goodsDetail.itemConstruction == '套装') {
                this.$notify.error(this.$t('请配置套装商品'));
                return;
            }
            goodDetail_1.addCar(req).then(res => {
                this.$router.push('/car');
            });
        });
    }
};
__decorate([
    store_1.AppModule.State
], GoodDetail.prototype, "firstCategory", void 0);
__decorate([
    store_1.AppModule.State
], GoodDetail.prototype, "secondCategory", void 0);
GoodDetail = __decorate([
    vue_property_decorator_1.Component({
        components: { Comment: index_vue_1.default, Commend: index_vue_2.default, copItem: cop_1.default,
            lopItem: Lop_1.default,
            wheelItem: wheel_1.default,
            guideItem: guide_1.default, Config: index_vue_3.default, HeaderTop: HeaderTop_vue_1.default, FooterBottom: () => Promise.resolve().then(() => __importStar(require('@/components/FooterBottom/Foot.vue'))) }
    })
], GoodDetail);
exports.default = GoodDetail;
